import { render, staticRenderFns } from "./detail.park.look.vue?vue&type=template&id=5bbabc0f&scoped=true&"
import script from "./detail.park.look.vue?vue&type=script&lang=js&"
export * from "./detail.park.look.vue?vue&type=script&lang=js&"
import style0 from "./detail.park.look.vue?vue&type=style&index=0&id=5bbabc0f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbabc0f",
  null
  
)

export default component.exports